import { FeedbackLabelsWrapper } from '@modules/feedback/components/FeedbackCard/FeedbackLabelList/FeedbackLabelsWrapper';
import { getSentimentChipColor } from '@modules/feedback/utils';
import { Chip, MenuItem, Stack, Typography, alpha } from '@mui/material';
import { useState } from 'react';
import { Feedback } from 'v2/core/entities/feedback';
import { SentimentLabel } from 'v2/core/entities/feedback/labels';
import { EditSentimentView } from '../EditPredictionsPanel/EditSentimentView';
import { mapSentimentNameToEdgeSentimentName } from '../utils';
import { SentimentPredictionLabelRightActions } from './SentimentPredictionLabelRightActions';

interface SentimentPredictionLabelProps {
  feedback: Feedback;
  label: SentimentLabel;
}

export const SentimentPredictionLabel = ({
  feedback,
  label,
}: SentimentPredictionLabelProps) => {
  const [isMenuItemHovered, setIsMenuItemHovered] = useState(false);
  const [isEditPredictionMode, setIsEditPredictionMode] = useState(false);

  const setEditPredictionMode = (isEditPredictionsMode: boolean) => {
    setIsEditPredictionMode(isEditPredictionsMode);
  };

  const onMenuItemMouseLeave = () => {
    // If sentiment is in edit mode, we want to
    // retain hovered behavior of menu item
    if (isEditPredictionMode) {
      return;
    }
    setIsMenuItemHovered(false);
  };

  const sentimentChipColor = getSentimentChipColor(label.displayName);

  return (
    <FeedbackLabelsWrapper>
      <MenuItem
        disableRipple
        onMouseEnter={() => setIsMenuItemHovered(true)}
        onMouseLeave={onMenuItemMouseLeave}
        sx={{
          borderRadius: 1,
          backgroundColor: (theme) =>
            isEditPredictionMode
              ? alpha(theme.palette.common.white, 0.08)
              : undefined,
          py: isEditPredictionMode ? 0 : undefined,
          pl: 0.5,
          pr: 1,
          mt: isMenuItemHovered ? -0.25 : 0,
          mb: isMenuItemHovered ? 0 : 0.25,
          cursor: 'default',
        }}
      >
        <Stack
          width="100%"
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          {isEditPredictionMode ? (
            <EditSentimentView
              feedback={feedback}
              sentiment={mapSentimentNameToEdgeSentimentName(label.displayName)}
            />
          ) : (
            <Chip
              size="medium"
              label={
                <Typography whiteSpace="normal" variant="caption">
                  {label.displayName}
                </Typography>
              }
              sx={{
                color: '#fff',
                bgcolor: sentimentChipColor,
                borderColor: sentimentChipColor,
                height: '100%',
              }}
              variant="filled"
            />
          )}
          {isMenuItemHovered && (
            <SentimentPredictionLabelRightActions
              recordID={feedback.id}
              isEditPredictionMode={isEditPredictionMode}
              setEditPredictionMode={setEditPredictionMode}
            />
          )}
        </Stack>
      </MenuItem>
    </FeedbackLabelsWrapper>
  );
};
